import React from "react";
import { Box, Flex, Grid, Input, Text, VStack } from "@chakra-ui/react";
import * as IconButton from "../themes/IconButtonSet";
import { formatNumber } from "../utils/reservationDocument";

// ส่วนแสดงรายการวัคซีนของใบจอง ใช้ร่วมกันระหว่างหน้าของเกษตรกรและของเจ้าหน้าที่

export const TotalsSummary = ({ totalQuantity, totalPrice }) => (
  <Flex
    w="100%"
    justify={{ base: "space-between", md: "flex-end" }}
    direction={{ base: "column", sm: "row" }}
    gap={{ base: 1, sm: 6 }}
    p={2}
    fontSize={{ base: "sm", md: "md" }}
  >
    <Text>
      <strong>รวมจำนวน (ขวด): </strong>
      {formatNumber(totalQuantity)}
    </Text>
    <Text>
      <strong>ราคารวมทั้งสิ้น (บาท): </strong>
      {formatNumber(totalPrice, { minimumFractionDigits: 2 })}
    </Text>
  </Flex>
);

// มุมมองการ์ดของรายการวัคซีน ใช้แทนตารางบนจอที่แคบเกินกว่าจะแสดง 6 คอลัมน์
export const VaccineDetailCards = ({
  details,
  isEditable,
  onQuantityChange,
  onRemove,
}) => {
  if (details.length === 0) {
    return (
      <Text color="gray.500" textAlign="center" py={6}>
        ยังไม่มีรายการวัคซีนที่สั่งจอง
      </Text>
    );
  }

  return (
    <VStack spacing={3} w="100%" align="stretch">
      {details.map((detail) => (
        <Box
          key={detail.VaccineID}
          borderWidth={1}
          borderRadius="lg"
          boxShadow="sm"
          p={{ base: 3, sm: 4 }}
        >
          <Flex justify="space-between" align="flex-start" gap={2} mb={3}>
            <Box minW={0}>
              <Text fontWeight="bold">{detail.VaccineID}</Text>
              <Text fontSize="sm" color="gray.600">
                {detail.name}
              </Text>
            </Box>
            {isEditable && (
              <IconButton.DeleteIcon
                onClick={() => onRemove(detail)}
                aria-label="ลบรายการ"
                size="sm"
                flexShrink={0}
              />
            )}
          </Flex>

          <Grid
            templateColumns="auto 1fr"
            gapX={3}
            gapY={2}
            fontSize="sm"
            alignItems="center"
            pt={3}
            borderTopWidth="1px"
            borderColor="gray.200"
          >
            <Text fontWeight="medium" color="gray.600">
              จำนวน (ขวด):
            </Text>
            {isEditable ? (
              <Input
                type="number"
                value={detail.RequestQuantity}
                onChange={(e) => onQuantityChange(detail.VaccineID, e.target.value)}
                min={0}
                size="sm"
                maxW="120px"
              />
            ) : (
              <Text>{formatNumber(detail.RequestQuantity)}</Text>
            )}

            <Text fontWeight="medium" color="gray.600">
              จำนวน (โดส):
            </Text>
            <Text>{formatNumber(detail.DoseCount)}</Text>

            <Text fontWeight="medium" color="gray.600">
              ราคา/ขวด:
            </Text>
            <Text>{formatNumber(detail.UnitPrice)} บาท</Text>

            <Text fontWeight="medium" color="gray.600">
              ราคารวม:
            </Text>
            <Text fontWeight="bold">{formatNumber(detail.TotalPrice)} บาท</Text>
          </Grid>
        </Box>
      ))}
    </VStack>
  );
};
